import { HTMLProps } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";

import { useIsInsideCardStack } from "./price-cards-stack.tsx";

export interface PriceCardSectionProps extends HTMLProps<HTMLDivElement> {
    first?: boolean;
    last?: boolean;
    firstCard?: boolean;
    lastCard?: boolean;
    outlined?: boolean;
}

// eslint-disable-next-line complexity
export const PriceCardSection = (props: PriceCardSectionProps) => {
    const {
        first,
        last,
        firstCard,
        lastCard,
        outlined,
        children,
        ...divProps
    } = props;
    const { isInsideCardStack } = useIsInsideCardStack();
    return (
        <div
            css={[
                priceCardSectionCss,
                css({
                    borderBlockStart: `solid 1px ${wacToken(
                        "color.neutral.light400"
                    )}`,
                    borderInlineStart: `solid 1px ${wacToken(
                        "color.neutral.light400"
                    )}`,
                    boxShadow: "none"
                }),

                // standalone card
                !isInsideCardStack &&
                    first &&
                    css({
                        borderStartStartRadius: "20px",
                        borderStartEndRadius: "20px"
                    }),
                !isInsideCardStack &&
                    css({
                        borderInlineEnd: `solid 1px ${wacToken(
                            "color.neutral.light400"
                        )}`
                    }),
                !isInsideCardStack &&
                    last &&
                    css({
                        borderBlockEnd: `solid 1px ${wacToken(
                            "color.neutral.light400"
                        )}`,
                        borderEndStartRadius: "20px",
                        borderEndEndRadius: "20px"
                    }),

                // standalone card, outlined
                !isInsideCardStack &&
                    outlined &&
                    css({
                        borderInlineStart: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`,
                        borderInlineEnd: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`
                    }),
                !isInsideCardStack &&
                    outlined &&
                    first &&
                    css({
                        borderBlockStart: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`
                    }),
                !isInsideCardStack &&
                    outlined &&
                    last &&
                    css({
                        borderBlockEnd: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`,
                        borderEndStartRadius: "20px",
                        borderEndEndRadius: "20px"
                    }),

                // in-stack card
                isInsideCardStack &&
                    css({
                        [media.below.md]: {
                            borderInlineEnd: `solid 1px ${wacToken(
                                "color.neutral.light400"
                            )}`
                        }
                    }),
                isInsideCardStack &&
                    first &&
                    css({
                        [media.below.md]: {
                            borderStartStartRadius: "20px",
                            borderStartEndRadius: "20px"
                        }
                    }),
                isInsideCardStack &&
                    last &&
                    css({
                        borderBlockEnd: `solid 1px ${wacToken(
                            "color.neutral.light400"
                        )}`,
                        [media.below.md]: {
                            "marginBlockEnd": "24px",
                            ":last-of-type": {
                                marginBlockEnd: "0"
                            }
                        }
                    }),
                isInsideCardStack &&
                    lastCard &&
                    css({
                        [media.above.md]: {
                            borderInlineEnd: `solid 1px ${wacToken(
                                "color.neutral.light400"
                            )}`
                        }
                    }),
                isInsideCardStack &&
                    firstCard &&
                    first &&
                    css({
                        [media.above.md]: {
                            borderStartStartRadius: "20px"
                        }
                    }),
                isInsideCardStack &&
                    lastCard &&
                    first &&
                    css({
                        [media.above.md]: {
                            borderStartEndRadius: "20px"
                        }
                    }),
                isInsideCardStack &&
                    lastCard &&
                    last &&
                    css({
                        [media.above.md]: {
                            borderEndEndRadius: "20px"
                        }
                    }),
                isInsideCardStack &&
                    firstCard &&
                    last &&
                    css({
                        [media.above.md]: {
                            borderEndStartRadius: "20px"
                        }
                    }),

                // in-stack card, outlined
                isInsideCardStack &&
                    outlined &&
                    first &&
                    css({
                        borderBlockStart: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`
                    }),
                isInsideCardStack &&
                    outlined &&
                    css({
                        [media.below.md]: {
                            borderInlineStart: `solid 1px ${wacToken(
                                "color.primary.black"
                            )}`,
                            borderInlineEnd: `solid 1px ${wacToken(
                                "color.primary.black"
                            )}`
                        },
                        [media.above.md]: {
                            borderInlineStart: `solid 1px ${wacToken(
                                "color.primary.black"
                            )}`,
                            borderInlineEnd: `solid 1px ${wacToken(
                                "color.primary.black"
                            )}`
                        }
                    }),
                isInsideCardStack &&
                    outlined &&
                    last &&
                    css({
                        borderBlockEnd: `solid 1px ${wacToken(
                            "color.primary.black"
                        )}`
                    })
            ]}
            {...divProps}
        >
            {children}
        </div>
    );
};

const priceCardSectionCss = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [media.above.md]: {
        width: "100%"
    },
    background: wacToken("color.neutral.light0")
});
